import Geocode from "react-geocode";

const GetLatLon = (addr) =>{
    
    return Geocode.fromAddress(addr)

}

export {GetLatLon}